import{ImageElement as e}from"./image-model.js";export const VideoElement=e.named("Video").props({type:"video",duration:0,startTime:0,endTime:1,volume:1});